import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class ClassesAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = "/api/classes";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getByInstructorId(id, router) {
    const url = `/api/classes/instructor/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getByStudentId(id, router) {
    const url = `/api/classes/student/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getByStudentActiveId(id, router) {
    const url = `/api/classes/activeStudent/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getByInstructorUserId(userId, router) {
    const url = `/api/classes/instructor/userId/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getByClassDetailsId(classId, router) {
    const url = `/api/classes/classDetails/${classId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getStudentsGradesByAssignmentList(students, assignments, router) {
    const url = `/api/classes/studentGradesByAssignments`;
    return this.CommonAPIService.postCall(url, {students, assignments}, router);
  }

  create(params, router) {
    const url = "/api/classes";
    return this.CommonAPIService.postCall(url, params, router);
  }
  delete(id, router) {
    const url = `/api/classes/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  update(class_id, params, router) {
    const url = `/api/classes/${class_id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  addStudentToClass(data, router) {
    const url = `/api/classes/addStudentToClass`;
    return this.CommonAPIService.postCall(url, data, router);
  }

  getGradeDetailsForClass(id, router){
    const url = `/api/classes/grades/${id}`
    return this.CommonAPIService.getCall(url, '', router)
  }

  getClassesDetailsForInstructor(id, router){
    const url = `/api/classes/grades/instructor/${id}`
    return this.CommonAPIService.getCall(url, '', router)
  }

  removeStudentFromClass(id, router){
    const url = `/api/classes/removeStudentToClass/${id}`
    return this.CommonAPIService.deleteCall(url, null, router)
  }

  archiveClass(classObj, router){
    const url = `/api/classes/archive`
    return this.CommonAPIService.postCall(url, classObj, router)
  }

  getArchiveClasses( router){
    const url = `/api/classes/archive`
    return this.CommonAPIService.getCall(url, '', router)
  }
}
export default ClassesAPIService;
